<style scoped lang="scss" type="text/scss">
    .type-selector-panel {
        display: flex;
        flex-wrap: nowrap;
        overflow: auto;

        .type-item {
            margin-bottom: 0;
            margin-right: .25rem;
            width: 5.5rem;
            min-width: 5.5rem;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }
</style>

<template>
    <div class="type-selector-panel">
        <square-info-block class="type-item" v-for="(item, index) in items" :key="index" :icon="item.icon"
                           :with-angle="false" :active="routeName === item.route_name"
                           @click.native="redirect(item.route_name)">
            {{ item.title }}
        </square-info-block>
    </div>
</template>

<script>
    import SquareInfoBlock from '../../../../../components/square-info-block/index';
    import ROUTE_NAMES from '../../../../../router/names';

    export default {
        name: '',
        components: {
            SquareInfoBlock
        },
        data () {
            return {
                items: [
                    {
                        title: '冠亚季军',
                        icon: '&#xe7b1;',
                        route_name: ROUTE_NAMES.ADMIN.COMPETITION.AWARD_CHAMPION
                    },
                    {
                        title: '标准奖项',
                        icon: '&#xe67e;',
                        route_name: ROUTE_NAMES.ADMIN.COMPETITION.AWARD_TRADITIONAL
                    },
                    {
                        title: '参赛队单项',
                        icon: '&#xe60b;',
                        route_name: ROUTE_NAMES.ADMIN.COMPETITION.AWARD_SPECIAL_PLAYER
                    },
                    {
                        title: '个人单项',
                        icon: '&#xe60b;',
                        route_name: ROUTE_NAMES.ADMIN.COMPETITION.AWARD_SPECIAL_MEMBER
                    }
                ]
            };
        },
        computed: {
            routeName () {
                return this.$route.name;
            }
        },
        methods: {
            redirect (routeName) {
                this.$router.push({
                    name: routeName
                });
            }
        }
    };
</script>
